import {
  PanelBody,
  TextareaControl,
  ColorPalette,
  Notice
} from "@wordpress/components";
import { InspectorControls } from "@wordpress/block-editor";
import { t } from "drupal";
import { useState, useEffect } from "@wordpress/element";

function PullQuoteSidePanel({
  quotation = "",
  name = "",
  textColorClass = "",
  onChangeQuotation,
  onChangeName,
  onChangeTextColorClass
}) {

  const textOptions = [
    { name: 'Purple', color: '#32006e', class: 'purple' },
    { name: 'Dark Grey', color: '#404040', class: 'darkgrey' },
    { name: 'Lite Grey', color: '#e5e5e5', class: 'litegrey' },
    { name: 'White', color: '#ffffff', class: 'white' },
    { name: 'Black', color: '#000000', class: 'black' },
  ];

  const quotationLength = quotation.length;
  const nameLength = name.length;

  const [errors, setErrors] = useState({
    quotation: !(quotation?.trim() ?? "")
  });

  useEffect(() => {
    setErrors({
      quotation: !quotation.trim()
    });
  }, [quotation]);


  return (
    <InspectorControls>
      <PanelBody title={t("Pull Quote Settings")} initialOpen>

        {errors.quotation && <Notice status="error">{t("Quotation is required")}</Notice>}
        <TextareaControl
          label={t("Quotation content")}
          value={quotation}
          placeholder={t("The important piece is to see how these things all connect to people and the ecosystem we live in. That's what environmental health does best")}
          required
          onChange={(value) => {
            onChangeQuotation(value);
            setErrors((prev) => ({ ...prev, quotation: !value.trim() }));
          }}
        />

        <p className="small">Character count: {quotationLength}</p>



        <TextareaControl
          label={t("Name")}
          value={name}
          onChange={onChangeName}
          placeholder={t("Michael Yost")}
        />

        <p class="small">{t("Character count")}: {nameLength}</p>

        <label className="form-label">{t("Text Color")}</label>
        <ColorPalette
          colors={textOptions}
          value={
            textOptions.find(opt => opt.class === textColorClass)?.color || ''
          }
          onChange={(colorHex) => {
            const selected = textOptions.find(opt => opt.color === colorHex);
            if (selected) {
              onChangeTextColorClass(selected.class);
            }
          }}

        />

      </PanelBody>
    </InspectorControls>
  );
}

export default PullQuoteSidePanel;
